'use strict';

angular.module('atex.dam').controller('DamAuthorModalController', ['$scope', '$rootScope', '$q', 'ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService', 'DamAuthorService',
  function($scope, $rootScope, $q, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService, DamAuthorService) {
    $scope.panelTitle = $scope.isNew ? $translate.getTranslationTable().__AUTHORS_NEW_DLG_TITLE_: $translate.getTranslationTable().__AUTHORS_MODIFY_DLG_TITLE__;

    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.author = atex.Content();
    $scope.isValid = false;

    DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      $scope.currentUserInfo = currentUserInfo;
      var template = 'atex.dam.standard.Author';

      DamTemplateService.getTemplateById(template).then(function (template) {
        $scope.template = angular.copy(template);
        $scope.author.template = $scope.template;

        if ($scope.isNew) {
          atex.onecms.ObjectUtils.accessor($scope.author.data, 'aspects/atex.OneCMS/data/createdWithTemplate').value = $scope.template.id;
          $scope.loaded = true;
          $scope.showSpinner = false;
        } else {

          DamAuthorService.getAuthor($scope.id).then(function (response) {
            $scope.author = angular.copy(response);
            $scope.loaded = true;
            $scope.showSpinner = false;
          }).then(null, function (error) {
            $scope.showSpinner = false;
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        }
      }).then(null, function (error) {
        $scope.showSpinner = false;
        alert(error.cause);
      });
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function publishAuthor (contentId){
      return DamService.publishContent(contentId).then(function (result) {
        DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__}), false);
      }).then(null, function (error) {
        error.messageHandled = true;
        var msg = $translate.getTranslationTable().__ERROR_DURING_EXPORT__;
        if (error.data && error.data.message) {
          msg = error.data.message;
        }
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: msg}), true);
      });
    }

    function isAuthorPublished (author){
      var isPublished = false;
      var engagementAspect = author.data.aspects.engagementAspect;
      if(engagementAspect){
        var engagementList = engagementAspect.data.engagementList;
        if (engagementList && engagementList.length > 0) {
          engagementList.forEach(function (engage) {
            engage.attributes.some(function (attr) {
              if (attr.name === "id" && attr.value && (attr.value.startsWith("ace:") || attr.value.startsWith("policy:"))){
                isPublished = true;
              }
            });
          });
        }
      }
      return isPublished;
    }

    function submit(cleanData) {

      if ($scope.isNew) {
        DamAuthorService.createAuthor(cleanData).then(function (response) {
          DamAuthorService.getAuthor(response.id).then(function (author) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(author);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          alert(error.cause);
        });
      } else {
        var updateInfo = {id: $scope.author.id, data: cleanData, revision: $scope.author.revision};
        DamAuthorService.updateAuthor(updateInfo).then(function (response) {
          DamAuthorService.getAuthor(response.id).then(function (folder) {
            $scope.$parent.doOk(folder);
            if(isAuthorPublished(folder)){
              publishAuthor(response.id).then(function() {
                $scope.showSpinner = false;
              }, function() {
                $scope.showSpinner = false;
              });
            }else {
              $scope.showSpinner = false;
            }
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          alert(error.cause);
        });
      }
    }

    $scope.doSave = function () {
      $scope.showSpinner = true;
      $scope.author.data.aspects.contentData.data.objectType = "author";
      var json = angular.toJson($scope.author.data);
      var cleanData = angular.fromJson(json);
      // Then check and warning if there is already an Author tied to the same loginName
      var loginName = atex.onecms.ObjectUtils.getByPath($scope.author, 'data/aspects/contentData/data/loginName');
      if (loginName) {
        DamAuthorService.loadAuthorByLoginName(loginName).then(function(author) {
          if (author && author.id !== $scope.author.id) {
            var authorName = atex.onecms.ObjectUtils.getByPath(author, 'data/aspects/contentData/data/name');
            $translate('__AUTHOR_ALREADY_EXISTS__', {authorName: authorName}).then(function(message){
              var answer = window.confirm(message);
              if (!answer) {
                $scope.showSpinner = false;
                return;
              }
              submit(cleanData);
            });
          } else {
            submit(cleanData);
          }
        });
      } else {
        submit(cleanData);
      }
    };

    $scope.checkIfValid = function () {
      var name = atex.onecms.ObjectUtils.getByPath($scope.author, "data/aspects/contentData/data/name");

      if (name) {
        $scope.isValid = true;
      } else {
        $scope.isValid = false;
      }
    };

    $scope.changeEndCallback = function (data) {
      $scope.author.data = data;
      $scope.dirty = true;
      $scope.checkIfValid();
      $scope.$digest();
      return;
    };

    $scope.initCallback = function () {
    };

    $scope.changeStartCallback = function () {
    };

    $scope.isOkEnabled = function () {
      return !$scope.showSpinner && $scope.isValid && $scope.dirty;
    };
  } ]);